import type { BiApiClientBase } from "./BiApiClientProviderContext.ts";
import { BiApiClientContext } from "./BiApiClientProviderContext.ts";

export const BiApiClientProvider = <T extends BiApiClientBase>({
  api,
  children,
}: {
  api: T;
  children: React.ReactNode;
}) => <BiApiClientContext value={api}>{children}</BiApiClientContext>;
